import { formatDateTime } from "@clipboard-health/date-time";
import { Alert, AlertTitle, Box, CircularProgress, Stack } from "@mui/material";
import { useGetWorkplace } from "@src/appV2/FacilityProfile/api/useGetWorkplace";
import { useGetWorkerLockStatus } from "@src/appV2/redesign/Chat/InHomeLock/api/useGetWorkerLockStatus";
import { Text } from "@src/lib/ui-react";

interface Props {
  workerId: string;
}

export function WorkerLockStatusDisplay(props: Props) {
  const { workerId } = props;

  const { lockData, isLocked, isLoading, isError } = useGetWorkerLockStatus({
    workerId,
  });

  const { data: workplaceData } = useGetWorkplace({
    workplaceId: lockData?.attributes.lockedByWorkplaceId,
  });

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (isError || !isLocked || !lockData) {
    return undefined;
  }

  const workplaceName = workplaceData?.data.attributes.name;

  return (
    <Alert severity="warning" sx={{ maxWidth: 600, alignItems: "center" }}>
      <AlertTitle>Visit Lock Active</AlertTitle>
      <Stack spacing={1}>
        <Box>
          <Text bold>Locking Workplace</Text>
          <Text>
            {workplaceName
              ? `${workplaceName} (${lockData.attributes.lockedByWorkplaceId})`
              : lockData.attributes.lockedByWorkplaceId}
          </Text>
        </Box>
        {lockData.attributes.lockReason && (
          <Box>
            <Text bold>Lock Reason</Text>
            <Text>{lockData.attributes.lockReason}</Text>
          </Box>
        )}
        {lockData.attributes.unlockCondition && (
          <Box>
            <Text bold>Unlock Condition</Text>
            <Text>{lockData.attributes.unlockCondition}</Text>
          </Box>
        )}
        <Box>
          <Text bold>Locked At</Text>
          <Text>{formatDateTime(lockData.attributes.lockedAt)}</Text>
        </Box>
      </Stack>
    </Alert>
  );
}
